import { i18nKeys } from '@/src/utils/i18n.utils';
import { joinClasses } from '@/src/utils/scss.utils';
import { IconProp } from '@fortawesome/fontawesome-svg-core';
import { faCircle } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React from 'react';
import { useTranslation } from 'react-i18next';
import styles from './Difficulty.module.scss';

interface IDifficultyProps {
  level: number;
}

const Difficulty: React.FC<IDifficultyProps> = ({ level }) => {
  const { t } = useTranslation();
  const severity: string[] = [
    t(i18nKeys.myJams.challenges.difficulty.easy),
    t(i18nKeys.myJams.challenges.difficulty.medium),
    t(i18nKeys.myJams.challenges.difficulty.hard),
  ];

  let difficultyStyle = styles.easy;

  if (level === 1) {
    difficultyStyle = styles.medium;
  } else if (level === 2) {
    difficultyStyle = styles.hard;
  }

  return (
    <span className={joinClasses(styles.container, difficultyStyle)}>
      <FontAwesomeIcon icon={faCircle as IconProp} size="xs" />
      <span>{severity[level]}</span>
    </span>
  );
};

export default Difficulty;
